/*
 * kelltoncommerce
 * version 1.0
 * http://www.kelltoncommerce.com
 *
 * Copyright (c) 2023  kellton tech solution limited
 * Author kellton ltd <support@kellton.com>
 * Licensed under the MIT license.
 */

export class PaymentDeleteModel {
  public paymentId: number;

  constructor(paymentdeleteForm: any) {
    this.paymentId = paymentdeleteForm.paymentId || '';
  }
}
